<template>
  <component
    :is="as"
    class="pro-label"
    v-bind="$attrs"
    v-on="$listeners"
    v-tooltip="{ content: tooltip, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
  >
    <slot v-if="$slots.default" />
    <span v-else>Pro</span>
  </component>
</template>

<script>
export default {
  props: {
    tooltip: String,
    as: {
      type: String,
      default: 'span',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.pro-label {
  font-size: 10px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 $gp * .25;
  font-weight: bold;
  color: $color-white;
  background-color: $color-green-1;
  text-transform: uppercase;
  border-radius: 2px;
  text-decoration: none !important;
}
</style>
